import { useState, type FC } from "react";
import { Button, Tooltip } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { createPortal } from "react-dom";
import { ReactComponent as FieldOperationsIcon } from "../../assets/images/list-btn-machinary.svg";

import { MachineryFieldOperationsComponent } from "./MachineryFieldOperations";
interface MachineryButtonComponentProps {
  onOpen?: () => void;
  onClose?: () => void;
  onClearSelection?: () => void;
  isSelected?: boolean;
}

const MachineryButtonComponent: FC<MachineryButtonComponentProps> = ({
  onOpen,
  onClose,
  onClearSelection,
  isSelected = false,
}) => {
  const [visible, setVisible] = useState<boolean>(false);
  const showDrawer = (): void => {
    setVisible(true);
    onOpen?.();
  };
  const closeFieldOperationsDrawer = (): void => {
    setVisible(false);
    onClose?.();
  };
  return (
    <div>
      <div className="corner-btn">
        <Tooltip title="Machinery Field Operations" placement="left">
          <Button
            aria-label="Open Machinery Field Operations"
            onClick={showDrawer}
            type="primary"
          >
            <FieldOperationsIcon className={isSelected ? "active" : ""} />
          </Button>
        </Tooltip>
        {(visible || isSelected) && (
          <Button
            aria-label="Close Machinery Field Operations"
            className="close-button"
            onClick={(e) => {
              e.stopPropagation();
              closeFieldOperationsDrawer();
              onClearSelection?.();
            }}
          >
            <CloseOutlined />
          </Button>
        )}
      </div>

      {/* adding a portal so that this component renders higher up the component and relatvie to the .map div */}
      {visible &&
        createPortal(
          <MachineryFieldOperationsComponent
            closeFieldOperationsDrawer={closeFieldOperationsDrawer}
          />,
          document.getElementById("trial-map") ?? document.body
        )}
    </div>
  );
};

export default MachineryButtonComponent;
